class RkSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.rk-slider');
    this.slides = this.querySelectorAll('.rk-slider__slide');
    this.prevButton = this.querySelector('.rk-slider-button--prev');
    this.nextButton = this.querySelector('.rk-slider-button--next');
    this.currentSlide = 0;

    this.prevButton.addEventListener('click', () => this.showPrevSlide());
    this.nextButton.addEventListener('click', () => this.showNextSlide());

    this.updateAspectRatios();
    window.addEventListener('resize', () => this.updateAspectRatios());
  }

  showPrevSlide() {
    this.currentSlide = (this.currentSlide > 0) ? this.currentSlide - 1 : this.slides.length - 1;
    this.updateSlider();
  }

  showNextSlide() {
    this.currentSlide = (this.currentSlide < this.slides.length - 1) ? this.currentSlide + 1 : 0;
    this.updateSlider();
  }

  updateSlider() {
    this.slider.style.transform = `translateX(-${this.currentSlide * 100}%)`;
  }

  updateAspectRatios() {
    this.slides.forEach(slide => {
      const desktopAspectRatio = slide.querySelector('.rk-slider__image--desktop').dataset.aspectRatio;
      const mobileAspectRatio = slide.querySelector('.rk-slider__image--mobile').dataset.aspectRatio;

      if (window.innerWidth > 767) {
        slide.style.paddingTop = `${100 / desktopAspectRatio}%`;
      } else {
        slide.style.paddingTop = `${100 / mobileAspectRatio}%`;
      }
    });
  }
}

customElements.define('rk-slider-component', RkSliderComponent);